"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideKybStatusSchema = exports.KYB_RATIONALE_MAX = exports.KYB_RATIONALE_MIN = exports.kybStatusSchema = exports.KYB_STATUSES = void 0;
const zod_1 = require("zod");
exports.KYB_STATUSES = ['Approved', 'Needs Review', 'Rejected'];
exports.kybStatusSchema = zod_1.z.enum(exports.KYB_STATUSES);
exports.KYB_RATIONALE_MIN = 20;
exports.KYB_RATIONALE_MAX = 2000;
exports.overrideKybStatusSchema = zod_1.z
    .object({
    to_status: exports.kybStatusSchema,
    rationale: zod_1.z.string().trim().min(exports.KYB_RATIONALE_MIN).max(exports.KYB_RATIONALE_MAX),
})
    .strict();
//# sourceMappingURL=override-status.js.map